import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const taiChinhMenu: NavMenu = {
  title: 'Tài chính',
  items: [
    {
      title: 'Phân tích báo cáo tài chính',
      items: [
        {
          title: 'Báo cáo kết quả hoạt động sản xuất kinh doanh theo đơn vị',
          href: '/tai-chinh/phan-tich-bao-cao-tai-chinh/bao-cao-ket-qua-hoat-dong-san-xuat-kinh-doanh-theo-don-vi'
        },
        {
          title: 'Bảng cân đối kế toán theo đơn vị',
          icon: <AritoIcon icon={870} />,
          href: '/tai-chinh/phan-tich-bao-cao-tai-chinh/bang-can-doi-ke-toan-theo-don-vi'
        },
        {
          title: 'Báo cáo doanh thu chi phí',
          icon: <AritoIcon icon={373} />,
          group: 0,
          href: '/tai-chinh/phan-tich-bao-cao-tai-chinh/bao-cao-doanh-thu-chi-phi'
        }
      ]
    },
    {
      title: 'Phân tích nhiều kỳ, nhiều đối tượng',
      items: [
        {
          title: 'Bảng cân đối kế toán cho nhiều kỳ',
          icon: <AritoIcon icon={229} />,
          href: '/tai-chinh/phan-tich-nhieu-ky-nhieu-doi-tuong/bang-can-doi-ke-toan-cho-nhieu-ky'
        },
        {
          title: 'Báo cáo kết quả hoạt động sản xuất kinh doanh cho nhiều kỳ',
          href: '/tai-chinh/phan-tich-nhieu-ky-nhieu-doi-tuong/bao-cao-ket-qua-hoat-dong-san-xuat-kinh-doanh-cho-nhieu-ky'
        },
        {
          title: 'Báo cáo kết quả hoạt động sản xuất kinh doanh theo đối tượng',
          icon: <AritoIcon icon={494} />,
          href: '/tai-chinh/phan-tich-nhieu-ky-nhieu-doi-tuong/bao-cao-ket-qua-hoat-dong-san-xuat-kinh-doanh-theo-doi-tuong'
        }
      ]
    }
  ]
};
